import * as types from '../../action-types';
import {getAllLanguages as initialState } from "../../initialState";

const getAllLanguages = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_LANGUAGES_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ALL_LANGUAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ALL_LANGUAGES_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ALL_LANGUAGES_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAllLanguages;
